{
  "familyId": "TAA-LEZEN-VERW",
  "questions": [
    {
      "id": "TAA-LEZEN-VERW-001",
      "familyId": "TAA-LEZEN-VERW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verwijswoorden",
      "questionType": "multiple_choice",
      "question": "'De kat sprong op de tafel. Daar lag een vis.' Waar verwijst 'daar' naar?",
      "options": ["de tafel", "de kat", "de vis", "de keuken"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verwijswoorden",
            "content": "'Daar' is een verwijswoord dat terugwijst naar een plaats die eerder in de tekst is genoemd. Zoek de plek die in de vorige zin wordt genoemd: 'de tafel'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwijswoord_daar",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.79,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.verw-daar-naar-persoon", "label": "'Daar' geïnterpreteerd als verwijzing naar persoon/dier", "optionIndex": 1 },
          { "id": "taa.verw-daar-naar-object", "label": "'Daar' geïnterpreteerd als verwijzing naar object i.p.v. plaats", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "'Daar' is een plaatsverwijswoord — het wijst terug naar een plaats in de vorige zin. De plaats in de eerste zin is 'de tafel'. De zin betekent: 'Op de tafel lag een vis.'",
        "solutionSteps": [
          "'Daar' = plaatsverwijswoord",
          "Zoek de plaats in de vorige zin: 'de tafel'",
          "'Daar' verwijst naar de tafel"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Daar' verwijst terug naar 'de tafel' — de plaats die in de vorige zin wordt genoemd.",
          "1": "Je dacht waarschijnlijk dat 'daar' naar de kat verwijst. Maar 'daar' is een plaatsverwijswoord en verwijst naar een plek, niet naar een dier. Onthoud: 'daar' = een plaats.",
          "2": "Je dacht waarschijnlijk dat 'daar' naar de vis verwijst. Maar de vis is wat er gevonden wordt, niet de plek. Onthoud: 'daar' verwijst naar de tafel (de plek waar de vis ligt).",
          "3": "Je dacht waarschijnlijk dat 'daar' naar de keuken verwijst. Maar 'de keuken' wordt nergens in de tekst genoemd. Onthoud: een verwijswoord wijst altijd terug naar iets dat eerder in de tekst staat."
        }
      }
    },
    {
      "id": "TAA-LEZEN-VERW-002",
      "familyId": "TAA-LEZEN-VERW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verwijswoorden",
      "questionType": "multiple_choice",
      "question": "'Emma en Sophie gingen naar het park. Ze speelden daar de hele middag.' Naar wie verwijst 'ze'?",
      "options": ["Emma en Sophie", "het park", "de hele middag", "de kinderen in het park"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verwijswoord 'ze'",
            "content": "'Ze' is een persoonlijk voornaamwoord dat terugwijst naar personen die eerder zijn genoemd. In de eerste zin worden Emma en Sophie genoemd. 'Ze' verwijst naar hen allebei (meervoud).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwijswoord_ze",
      "variantIndex": 2,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.80,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.verw-ze-naar-plaats", "label": "'Ze' geïnterpreteerd als verwijzing naar een plaats", "optionIndex": 1 },
          { "id": "taa.verw-ze-naar-tijd", "label": "'Ze' geïnterpreteerd als verwijzing naar een tijdsaanduiding", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "'Ze' is een persoonlijk voornaamwoord (meervoud) — het wijst terug naar de personen in de vorige zin: Emma en Sophie. De zin betekent: 'Emma en Sophie speelden daar de hele middag.'",
        "solutionSteps": [
          "'Ze' = persoonlijk voornaamwoord (meervoud)",
          "Zoek de personen in de vorige zin: Emma en Sophie",
          "'Ze' verwijst naar Emma en Sophie"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Ze' verwijst naar Emma en Sophie — de twee personen uit de eerste zin.",
          "1": "Je dacht waarschijnlijk dat 'ze' naar het park verwijst. Maar 'ze' verwijst naar personen, niet naar een plaats. Onthoud: 'daar' verwijst naar het park, 'ze' verwijst naar Emma en Sophie.",
          "2": "Je dacht waarschijnlijk dat 'ze' naar de hele middag verwijst. Maar 'de hele middag' is een tijdsaanduiding, niet een persoon. Onthoud: 'ze' verwijst naar personen.",
          "3": "Je dacht waarschijnlijk dat er andere kinderen bedoeld worden. Maar er worden geen andere kinderen in de tekst genoemd. Onthoud: verwijswoorden wijzen terug naar woorden die eerder in de tekst staan."
        }
      }
    },
    {
      "id": "TAA-LEZEN-VERW-003",
      "familyId": "TAA-LEZEN-VERW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verwijswoorden",
      "questionType": "multiple_choice",
      "question": "'De hond rende naar de bal. Hij pakte hem op.' Waar verwijst 'hem' naar?",
      "options": ["de bal", "de hond", "een ander dier", "de eigenaar"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verwijswoord 'hem'",
            "content": "'Hij' verwijst naar de hond (onderwerp). 'Hem' verwijst naar het andere zelfstandig naamwoord: de bal. De hond pakte de bal op.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwijswoord_hem",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.verw-hem-naar-onderwerp", "label": "'Hem' geïnterpreteerd als verwijzing naar het onderwerp (de hond)", "optionIndex": 1 },
          { "id": "taa.verw-hem-niet-in-tekst", "label": "'Hem' geïnterpreteerd als verwijzing naar een persoon die niet in de tekst staat", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "'Hij' = onderwerp = de hond. 'Hem' = lijdend voorwerp = de bal. De zin betekent: 'De hond pakte de bal op.'",
        "solutionSteps": [
          "'Hij' = onderwerp = de hond",
          "'Hem' = lijdend voorwerp = de bal",
          "De hond (hij) pakte de bal (hem) op"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Hem' verwijst naar 'de bal'. De hond (hij) pakte de bal (hem) op.",
          "1": "Je dacht waarschijnlijk dat 'hem' naar de hond verwijst. Maar 'de hond' wordt al aangeduid met 'hij' (onderwerp). Onthoud: 'hem' verwijst naar het andere woord: de bal.",
          "2": "Je dacht waarschijnlijk dat er een ander dier bedoeld wordt. Maar er wordt geen ander dier in de tekst genoemd. Onthoud: verwijswoorden wijzen terug naar woorden die eerder in de tekst staan.",
          "3": "Je dacht waarschijnlijk dat 'hem' naar de eigenaar verwijst. Maar er wordt geen eigenaar in de tekst genoemd. Onthoud: 'hem' verwijst naar de bal — het enige andere zelfstandig naamwoord."
        }
      }
    },
    {
      "id": "TAA-LEZEN-VERW-004",
      "familyId": "TAA-LEZEN-VERW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verwijswoorden",
      "questionType": "multiple_choice",
      "question": "'Tom las een boek over dinosaurussen. Dat vond hij heel spannend.' Waar verwijst 'dat' naar?",
      "options": ["het boek lezen", "dinosaurussen", "Tom", "het boek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verwijswoord 'dat'",
            "content": "'Dat' kan verwijzen naar een heel zinsdeel of een handeling. Tom las een boek → 'dat' (het lezen van het boek) vond hij spannend.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwijswoord_dat",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.verw-dat-naar-object-ipv-handeling", "label": "'Dat' geïnterpreteerd als verwijzing naar object i.p.v. handeling", "optionIndex": 1 },
          { "id": "taa.verw-dat-naar-persoon", "label": "'Dat' geïnterpreteerd als verwijzing naar een persoon", "optionIndex": 2 },
          { "id": "taa.verw-dat-naar-object-ipv-handeling", "label": "'Dat' geïnterpreteerd als enkel object (het boek) i.p.v. handeling", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "'Dat' verwijst hier naar de hele handeling: 'Tom las een boek over dinosaurussen.' Het lezen van het boek vond hij spannend.",
        "solutionSteps": [
          "'Dat' = verwijswoord naar een handeling",
          "De handeling: Tom las een boek over dinosaurussen",
          "'Dat' verwijst naar het lezen van het boek"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Dat' verwijst naar de hele handeling: het lezen van het boek over dinosaurussen.",
          "1": "Je dacht waarschijnlijk dat 'dat' naar dinosaurussen verwijst. Maar dinosaurussen zijn het onderwerp van het boek, niet de handeling. Onthoud: 'dat' verwijst naar wat Tom deed: het boek lezen.",
          "2": "Je dacht waarschijnlijk dat 'dat' naar Tom verwijst. Maar Tom wordt al aangeduid met 'hij'. Onthoud: 'dat' verwijst naar de handeling, niet naar de persoon.",
          "3": "Je dacht waarschijnlijk dat 'dat' alleen naar het boek verwijst. Maar 'dat' verwijst naar de hele handeling (het lezen van het boek), niet alleen naar het boek zelf. Onthoud: 'dat' kan naar een heel zinsdeel verwijzen."
        }
      }
    },
    {
      "id": "TAA-LEZEN-VERW-005",
      "familyId": "TAA-LEZEN-VERW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verwijswoorden",
      "questionType": "multiple_choice",
      "question": "'De juf legde de opdracht uit aan de klas. Zij begreep het meteen.' Naar wie verwijst 'zij'?",
      "options": ["de klas", "de juf", "de opdracht", "een leerling"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verwijswoord 'zij' — meervoud of enkelvoud?",
            "content": "'Zij' kan enkelvoud (vrouwelijk) of meervoud zijn. Hier verwijst 'zij' naar 'de klas' (meervoud: de leerlingen). De juf legde uit, de klas begreep het. Let op: als 'zij' naar de juf verwees, zou de zin weinig toevoegen (de juf begrijpt haar eigen uitleg).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwijswoord_zij_meervoud",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.verw-zij-enkelvoud-vs-meervoud", "label": "'Zij' enkelvoud (de juf) i.p.v. meervoud (de klas)", "optionIndex": 1 },
          { "id": "taa.verw-zij-naar-niet-persoon", "label": "'Zij' geïnterpreteerd als verwijzing naar een niet-persoon (de opdracht)", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "'Zij' verwijst hier naar 'de klas' (de leerlingen). De juf legde de opdracht uit, en de klas begreep het meteen. Het zou weinig zin hebben als 'zij' naar de juf verwees — de juf begrijpt haar eigen uitleg al.",
        "solutionSteps": [
          "'Zij' kan enkelvoud of meervoud zijn",
          "De juf legde uit → wie moet het begrijpen? → de klas",
          "Logisch: de klas begreep het meteen",
          "'Zij' verwijst naar de klas"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Zij' verwijst naar 'de klas'. De leerlingen begrepen de opdracht meteen.",
          "1": "Je dacht waarschijnlijk dat 'zij' naar de juf verwijst. Dat is grammaticaal mogelijk, maar inhoudelijk onlogisch: de juf begrijpt haar eigen uitleg al. Onthoud: kies het antwoord dat inhoudelijk het meest logisch is.",
          "2": "Je dacht waarschijnlijk dat 'zij' naar de opdracht verwijst. Maar een opdracht kan niet 'begrijpen'. Onthoud: 'zij' verwijst naar een persoon of groep personen.",
          "3": "Je dacht waarschijnlijk dat er één leerling bedoeld wordt. Maar er wordt geen individuele leerling genoemd. 'De klas' is de groep die de uitleg ontvangt. Onthoud: verwijswoorden wijzen terug naar woorden die in de tekst staan."
        }
      }
    },
    {
      "id": "TAA-LEZEN-VERW-006",
      "familyId": "TAA-LEZEN-VERW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verwijswoorden",
      "questionType": "text_highlight",
      "question": "Markeer het verwijswoord in de tweede zin.",
      "data": {
        "text": "De kinderen speelden in het park. Daar was het altijd gezellig.",
        "correctHighlights": [{ "start": 32, "end": 36 }]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verwijswoorden herkennen",
            "content": "Een verwijswoord vervangt een woord dat eerder in de tekst staat. 'Daar' verwijst terug naar 'het park'. Andere verwijswoorden: hij, zij, het, die, dat, daar, er.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwijswoord_highlight",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "'Daar' is het verwijswoord — het verwijst terug naar 'het park' uit de eerste zin. De zin betekent: 'In het park was het altijd gezellig.'",
        "solutionSteps": [
          "Zoek het woord dat terugwijst naar iets uit de eerste zin",
          "'Daar' vervangt 'in het park'",
          "'Daar' is het verwijswoord"
        ]
      }
    },
    {
      "id": "TAA-LEZEN-VERW-007",
      "familyId": "TAA-LEZEN-VERW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verwijswoorden",
      "questionType": "matching",
      "question": "Koppel elk verwijswoord aan waar het naar verwijst.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["daar", "hij", "ze", "dat"],
        "rightItems": ["een persoon (man)", "een plaats", "meerdere personen", "een handeling of ding"],
        "correctMatches": {"0": 1, "1": 0, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Soorten verwijswoorden",
            "content": "'Daar' verwijst naar een plaats. 'Hij' verwijst naar een mannelijk persoon. 'Ze' verwijst naar meerdere personen (of een vrouw). 'Dat' verwijst naar een handeling of een het-woord.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwijswoord_koppelen",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Elk verwijswoord heeft een eigen functie: 'daar' → plaats, 'hij' → mannelijk persoon, 'ze' → meerdere personen, 'dat' → handeling of het-woord.",
        "solutionSteps": [
          "'Daar' verwijst naar een plaats (bijv. 'het park')",
          "'Hij' verwijst naar een mannelijk persoon (bijv. 'de jongen')",
          "'Ze' verwijst naar meerdere personen (bijv. 'de kinderen')",
          "'Dat' verwijst naar een handeling of ding (bijv. 'het lezen')"
        ]
      }
    },
    {
      "id": "TAA-LEZEN-VERW-008",
      "familyId": "TAA-LEZEN-VERW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verwijswoorden",
      "questionType": "text_highlight",
      "question": "Tik het woord waar 'daar' naar verwijst.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "tap_referent",
        "passage": "De kat sprong op de tafel. Daar lag een vis.",
        "pronounIndex": 6,
        "candidateIndices": [1, 4, 9],
        "correctIndex": 4
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "referenceArrow",
          "showWhen": "wrong",
          "data": {
            "sentence": "De kat sprong op de tafel. Daar lag een vis.",
            "pronounIndex": 6,
            "referentIndex": 4,
            "label": "'Daar' verwijst naar 'tafel'"
          }
        }
      ],
      "conceptId": "verwijswoord_tap_referent_daar",
      "variantIndex": 8,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "'Daar' is een plaatsverwijswoord. Het verwijst terug naar de plaats die in de vorige zin wordt genoemd: 'de tafel'. De vis lag op de tafel.",
        "solutionSteps": [
          "Lees de eerste zin: 'De kat sprong op de tafel.'",
          "'Daar' = plaatsverwijswoord — zoek een plaats",
          "De plaats in de vorige zin is 'tafel'",
          "Tik op 'tafel'"
        ]
      }
    },
    {
      "id": "TAA-LEZEN-VERW-009",
      "familyId": "TAA-LEZEN-VERW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_verwijswoorden",
      "questionType": "text_highlight",
      "question": "Tik het woord waar 'die' naar verwijst.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "tap_referent",
        "passage": "De jongen pakte het boek dat op de plank lag. Die was zwaar.",
        "pronounIndex": 11,
        "candidateIndices": [1, 3, 7],
        "correctIndex": 3
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "referenceArrow",
          "showWhen": "wrong",
          "data": {
            "sentence": "De jongen pakte het boek dat op de plank lag. Die was zwaar.",
            "pronounIndex": 11,
            "referentIndex": 3,
            "label": "'Die' verwijst naar 'boek'"
          }
        }
      ],
      "conceptId": "verwijswoord_tap_referent_die",
      "variantIndex": 9,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "'Die' verwijst terug naar het zelfstandig naamwoord 'boek'. Het boek was zwaar — niet de jongen of de plank.",
        "solutionSteps": [
          "Vraag: wat was zwaar?",
          "Niet de jongen, niet de plank",
          "Het zware ding is 'boek'",
          "'Die' verwijst naar 'boek'"
        ]
      }
    }
  ]
}